import { useState, useCallback } from 'react';
import { useNotifications } from '@medprompt/shared';

const useConsultationDelete = ({ consultationId, consultationService, discardRecording, navigate }) => {
  const { addNotification } = useNotifications();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const openDeleteModal = useCallback(() => setDeleteModalOpen(true), []);
  const closeDeleteModal = useCallback(() => setDeleteModalOpen(false), []);

  const confirmDelete = useCallback(async () => {
    try {
      setDeleteLoading(true);
      discardRecording();
      await consultationService.deleteConsultation(consultationId);
      addNotification('consultation-deleted', 'Consultation deleted');
      // The delete is confirmed, so leave now. The NON_EXISTENT event stays the path for other
      // users; waiting for it here left this user on a consultation that no longer exists.
      navigate('/', { state: { selectTab: 'scribe' } });
    } catch (err) {
      console.error('Error deleting consultation:', err);
      addNotification('delete-error', 'Failed to delete consultation', { isError: true });
    } finally {
      setDeleteLoading(false);
      setDeleteModalOpen(false);
    }
  }, [consultationId, consultationService, discardRecording, navigate, addNotification]);

  return { deleteModalOpen, deleteLoading, openDeleteModal, closeDeleteModal, confirmDelete };
};

export default useConsultationDelete;
